import { Component, Input, OnInit } from '@angular/core';
//import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseService } from 'src/app/system-common/services/base.service';
import { AgentRelationService } from '../services/agentRelation.service';

@Component({
  selector: '',
  template: '',
})
export class TeamAgentRelationSearchHandler extends BaseSearchComponent<AgentRelationService> implements OnInit {
  public searchName: string;
  // public fullPath;
  isAdvanceSearchDisplayed: boolean;
  searchCriteriaData: any;

  constructor(
    public service: AgentRelationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    // const pathSegments = this.route.snapshot.url;
    // this.fullPath = pathSegments.map((segment) => segment.path).join('/');
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchName = 'SearchTeamRelation';
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'TeamRelation',
        link: '/search-team-agent-relations',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('TeamRelation');
    return header;
  }
}
